import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import constants from "../../utils/constants";
// import styles from './PendingAmountInfo.scss';
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from "react-intl";

const msgs = defineMessages({
  payAtProperty: {
    id: "checkout.payment_form.payAtProperty",
    description: "Label which indicates if reservation is paid at the property",
    defaultMessage: "Pay at the property",
  },
  payAtHotel: {
    id: "checkout.payAtHotel",
    description: "Pay at the hotel",
    defaultMessage: "Pay at the hotel",
  },
  pendingPayment: {
    id: "checkout.pendingPayment",
    description: "Pending payment",
    defaultMessage: "Pending payment",
  },
  payAccordingToConditions: {
    id: "checkout.payment_form.remainingConditions",
    description: "Label which indicates if reservation is paid at the property",
    defaultMessage: "Remainder, to be paid according to the conditions.",
  },
  amountRemaining: {
    id: "checkout.payment_form.remaining",
    description: "Label which indicates if reservation is paid at the property",
    defaultMessage: "Remainder",
  },
});
export function getPendingAmountMessage(pendingAmountTextConfiguration) {
  let message = msgs.payAtProperty;
  switch (pendingAmountTextConfiguration) {
    case constants.PENDING_AMOUNT_TEXT_CONFIGURATION.PAY_AT_HOTEL:
      message = msgs.payAtHotel;
      break;
    case constants.PENDING_AMOUNT_TEXT_CONFIGURATION.PENDING_PAYMENT:
      message = msgs.pendingPayment;
      break;
    case constants.PENDING_AMOUNT_TEXT_CONFIGURATION.PAY_ACCORDING_TO_CONDITIONS:
      message = msgs.payAccordingToConditions;
      break;
    case constants.PENDING_AMOUNT_TEXT_CONFIGURATION.AMOUNT_REMAINING:
      message = msgs.amountRemaining;
      break;
    default:
      message = msgs.payAtProperty;
      break;
  }
  return message;
}
function PendingAmountInfo({
  section,
  pendingAmount,
  pendingAmountTextConfiguration,
  percentage,
  fullWidth,
}) {
  const percentageVal =
    percentage !== null && typeof percentage !== "undefined" ? percentage : null;

  if (pendingAmount === null || pendingAmount <= 0) {
    return null;
  }

  if (pendingAmountTextConfiguration === constants.PENDING_AMOUNT_TEXT_CONFIGURATION.NO_TEXT) {
    return null;
  }

  if (section === constants.PENDING_AMOUNT_INFO_SECTION.AMOUNT) {
    return (
      <div>
        <FormattedNumber
          value={pendingAmount}
          minimumFractionDigits={2}
          maximumFractionDigits={2}
        />
      </div>
    );
  }

  if (fullWidth) {
    return null;
  }

  if (section === constants.PENDING_AMOUNT_INFO_SECTION.TEXT) {
    const message = getPendingAmountMessage(pendingAmountTextConfiguration);
    return (
      <div>
        <FormattedMessage {...message} />
        {percentageVal !== null && " ("}
        {percentageVal !== null && <FormattedNumber value={percentage} style="percent" />}
        {percentageVal !== null && ")"}
      </div>
    );
  }
  return null;
}

PendingAmountInfo.propTypes = {
  PendingAmountTextConfiguration: PropTypes.string,
};

export default injectIntl(pure(PendingAmountInfo));
